import { useState, useEffect, useRef } from "react";

import "react-datepicker/dist/react-datepicker.css";

import User from "views/userLeague/header/inviteUser/user";
import SendInvite from "views/userLeague/header/inviteUser/sendInvite";
import { Capacitor } from "@capacitor/core";
import { useTranslation } from "react-i18next";

import {
  IonContent,
  IonList,
  IonLabel,
  IonSearchbar,
  IonListHeader,
} from "@ionic/react";

import algoliasearch from "algoliasearch/lite";

const InviteUser = () => {
  const { t } = useTranslation();

  const searchClient = algoliasearch(
    process.env.REACT_APP_ALGOLIA_APP_ID,
    process.env.REACT_APP_ALGOLIA_API_KEY
  );
  const index = searchClient.initIndex("users");
  const [events, setEvents] = useState([]);
  const [searchString, setSearchString] = useState("");

  const updateFilter = (value) => {
    setSearchString(value.target.value);

    if (value.length < 2) {
      setEvents([]);
    }
  };

  useEffect(() => {
    if (searchString.length > 2) {
      index
        .search(searchString, {
          hitsPerPage: 10,
        })
        .then(({ hits }) => {
          setEvents(hits);
        })
        .catch((error) => {
          console.error("Algolia search error:", error);
        });
    }
  }, [searchString]);

  const userList = [...events].map((event) => <User item={event} />);

  return (
    <IonContent>
      <IonListHeader mode="ios">
        <IonLabel>{t("tournament.invite.title")}</IonLabel>
      </IonListHeader>
      {Capacitor.isNativePlatform() && (
        <div className="flex w-full px-2">
          <SendInvite />
        </div>
      )}
      <IonSearchbar
        class="custom"
        mode="ios"
        // debounce={1000}
        placeholder={t("tournament.invite.search")}
        onIonInput={(ev) => updateFilter(ev)}
      ></IonSearchbar>

      <IonList>{userList}</IonList>
    </IonContent>
  );
};

export default InviteUser;
